// eslint-disable-next-line import/prefer-default-export
export const newIfChanged = (oldState, newState) => {
    if (JSON.stringify(oldState) === JSON.stringify(newState)) {
        return oldState;
    }

    return newState;
};
